import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation } from 'react-query';

export interface OAuthUrlResponse {
  userId: number;
  url: string;
}

const generatePodiumOAuthUrl = async (): Promise<void> => {
  const response = await EXPRESS_API.get<OAuthUrlResponse>(`podium/oauth/url`);
  const { url } = response.data;
  window.open(url, '_blank');
};

export const usePodiumOAuthUrlMutation = () => {
  return useMutation<void, Error, void>(() => generatePodiumOAuthUrl());
};
